var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 14.8004C14.8 13.4749 15.8745 12.4004 17.2 12.4004H22.7029C23.3395 12.4004 23.9499 12.6532 24.4 13.1033L28.497 17.2004C28.9471 17.6505 29.2 18.2609 29.2 18.8974V29.2004C29.2 30.5259 28.1255 31.6004 26.8 31.6004H17.2C15.8745 31.6004 14.8 30.5259 14.8 29.2004V14.8004ZM17.2 22.0004C17.2 21.3376 17.7372 20.8004 18.4 20.8004H25.6C26.2627 20.8004 26.8 21.3376 26.8 22.0004C26.8 22.6631 26.2627 23.2004 25.6 23.2004H18.4C17.7372 23.2004 17.2 22.6631 17.2 22.0004ZM18.4 25.6004C17.7372 25.6004 17.2 26.1376 17.2 26.8004C17.2 27.4631 17.7372 28.0004 18.4 28.0004H25.6C26.2627 28.0004 26.8 27.4631 26.8 26.8004C26.8 26.1376 26.2627 25.6004 25.6 25.6004H18.4Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.cadd5fba55603743f878a8e6de5ac2c0.svg";
export { ForwardRef as ReactComponent };